var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 2.51157C25.5 1.13657 24.375 0.0115662 23 0.0115662H3C1.625 0.0115662 0.5 1.13657 0.5 2.51157V17.5116C0.5 18.8866 1.625 20.0116 3 20.0116H23C24.375 20.0116 25.5 18.8866 25.5 17.5116V2.51157ZM23 2.51157L13 8.76157L3 2.51157H23ZM23 17.5116H3V5.01157L13 11.2616L23 5.01157V17.5116Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.4072cb826c4e7ff4ed99330cdc162c4c.svg";
export { ForwardRef as ReactComponent };